export default __webpack_public_path__ + "static/media/Monocal-D-Box-eng.541459e1.jpg";